import React, { useEffect } from "react";
import { Form, Button, Upload, message } from "antd";
import { Paperclip } from "lucide-react";
import { Input } from "./ui/input-field";
import { Textarea } from "./ui/textarea";
import { cn } from "../lib/utils";

const SubjectField = (props) => (
  <div className="w-full space-y-1">
    <label className="block text-sm font-normal text-[#6D6584] lg:hidden">
      Subject
    </label>
    <label className="hidden lg:block text-[14px] font-normal text-[#6D6584]">
      Subject line
    </label>
    <Input
      {...props}
      name="subject"
      type="text"
      text={undefined}
      placeholder="Enter subject"
      state="default"
      className="!py-[27px] border-[1px] !text-[16px] !text-[#423E51] font-plusjakarta rounded-[16px] bg-white"
    />
  </div>
);

const LabeledTextarea = ({ value, onChange, ...props }) => (
  <div className="w-full space-y-1">
    <label className="block text-sm font-normal text-[#33125F] lg:text-[#6D6584]">
      Your message
    </label>
    <div
      className={cn(
        "rounded-[16px] p-[2px] transition-[background] duration-200 bg-[#CECBD7]",
        "focus-within:bg-[linear-gradient(86.72deg,#57249C_-10.66%,#EB3366_113.47%)]",
        "lg:p-0 lg:bg-transparent"
      )}
    >
      <Textarea
        value={value}
        onChange={onChange}
        rows={10}
        className={cn(
          "py-4 border-0 !text-[16px] !text-[#423E51] font-plusjakarta rounded-[14px] bg-white w-full",
          "focus:shadow-none focus:outline-none resize-none",
          "lg:rounded-[16px] lg:border lg:border-[#CECBD7] lg:focus:border-[#57249C]",
          "placeholder:text-[#423E51] "
        )}
        placeholder="Type your message here..."
        {...props}
      />
    </div>
  </div>
);

const SupportTicketForm = ({ onFinish, initialValues = {}, loadingTicket }) => {
  const [form] = Form.useForm();

  const beforeUpload = (file) => {
    message.success(`${file.name} file uploaded successfully`);
    const prev = form.getFieldValue("image");
    const fileList = Array.isArray(prev?.fileList) ? prev.fileList : [];
    form.setFieldValue("image", {
      fileList: [...fileList, { originFileObj: file }],
    });
    return false;
  };

  useEffect(() => {
    form.setFieldsValue(initialValues);
  }, [form, initialValues]);

  return (
    <Form
      layout="vertical"
      onFinish={onFinish}
      initialValues={initialValues}
      className="w-full"
    >
      <Form.Item
        name="subject"
        rules={[{ required: true, message: "Please enter the subject" }]}
      >
        <SubjectField />
      </Form.Item>

      <Form.Item name="description" className="lg:mb-3 mb-6">
        <LabeledTextarea />
      </Form.Item>

      <Form.Item name="image" className="mb-6 w-full">
        <div className="w-full space-y-1">
          <label className="sr-only">Attachment (optional)</label>
          <Upload
            beforeUpload={beforeUpload}
            multiple
            className={cn(
              "w-full block",
              "[&_.ant-upload]:!block [&_.ant-upload]:w-full"
            )}
          >
            <div className="flex items-center justify-center w-full min-w-0 py-3 px-4 rounded-full border border-[#F1EDF7] text-[#6D6584] font-plusjakarta text-[16px] cursor-pointer hover:opacity-90 transition-opacity lg:bg-transparent lg:border-0 lg:justify-start lg:py-0 lg:px-0">
              <Paperclip
                size={18}
                className="mr-2 flex-shrink-0 lg:rotate-45 -rotate-45"
              />
              <span className="font-medium text-[#33125F] lg:text-[16px] lg:underline-offset-2 lg:underline">
                Attach file
              </span>
            </div>
          </Upload>
        </div>
      </Form.Item>

      <Form.Item className="mb-0 lg:flex block justify-center">
        <Button
          type="button"
          htmlType="submit"
          loading={loadingTicket}
          className="lg:w-[309px] h-[48px] w-full mx-auto bg-[linear-gradient(86.72deg,#57249C_-10.66%,#EB3366_113.47%)] text-white font-semibold text-[14px] py-[11px] px-8 rounded-full border-0 transition duration-300 ease-in-out hover:scale-[1.02] hover:opacity-90 font-plusjakarta"
        >
          Send message
        </Button>
      </Form.Item>
    </Form>
  );
};

export default SupportTicketForm;
